<div class="py-12 flex flex-col items-center bg-gray-50 rounded-2xl">
  <h4 class="text-black-500 font-bold text-2xl">میزبان ایران هتل آنلاین شوید</h4>
  <p class="text-black-300 my-6">
    آیا می خواهید از طریق فناوری پیشرفته یا محتوای قوی، اقامتگاه خود را به گردشگران معرفی کنید.
  </p>
  <!-- desktop -->
  <a target="_blank" href="https://iranhotelonline.porsline.ir/s/villa" class="hidden md:inline-block" rel="nofollow">
    <button class="bg-blue-500 text-white !font-medium px-6 py-2 rounded-lg">میزبان شوید</button>
  </a>
  <!-- mobile -->
  <a href="https://iranhotelonline.porsline.ir/s/villa" class="md:hidden" rel="nofollow">
    <button class="bg-blue-500 text-white !font-medium px-6 py-2 rounded-lg">میزبان شوید</button>
  </a>
</div>